import { render, staticRenderFns } from "./OptionsList.vue?vue&type=template&id=5d475df0"
import script from "./OptionsList.vue?vue&type=script&lang=js"
export * from "./OptionsList.vue?vue&type=script&lang=js"
import style0 from "./OptionsList.vue?vue&type=style&index=0&id=5d475df0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports